import { PaymentMethodOptions } from '@/enums/paymentMethods';

export default value => {
    const foundOption = PaymentMethodOptions.find(
        option => option.value === value
    );

    return foundOption?.text || value || '-';
};
